import { ErrorMessageWrapper } from '@/common/components/ErrorMessageWrapper'
import ListHeader from '@/common/components/ListHeader'
import Table from '@/common/components/Table'
import TextField from '@/common/components/TextField'
import useDebounce from '@/common/hooks/useDebounce'
import { useFilterParams } from '@/common/hooks/useFilterParams'
import { Mapper } from '@/common/services/mapper'
import { defaultColumns } from '@/features/productNfceMappings/constants/columns.constant'
import { useProductNfceMappings } from '@/features/productNfceMappings/hooks/useProductNfceMappings'
import { ProductNfceMappingsTransformer } from '@/features/productNfceMappings/services/productNfceMappingsTransformer'
import {
  ProductNfceMappingData,
  ProductNfceMappingTableItem,
} from '@/features/productNfceMappings/types/productNfceMapping'
import { FileBox, Search } from 'lucide-react'

const ProductNfceMappingsList = () => {
  const { filterParams, setFilterParams } = useFilterParams()

  const [search, setSearch] = useDebounce(filterParams.search || '')

  const {
    data: productNfceMappings,
    meta,
    isPending: isPendingProductNfceMappings,
    isLoading: isLoadingProductNfceMappings,
    error: productNfceMappingsError = {} as any,
    refetch: refetchProductNfceMappings,
  } = useProductNfceMappings({
    filters: {
      search: search,
      page: filterParams.page || 1,
    },
    mapper: Mapper.mapWithTransformer<ProductNfceMappingData[], ProductNfceMappingTableItem[]>({
      transformer: ProductNfceMappingsTransformer.tableTransformer(),
    }),
  })

  return (
    <div>
      <div className="flex flex-col gap-6">
        <ListHeader
          Icon={<FileBox className="w-10 h-10" strokeWidth={1.5} />}
          title="Mapeamento de Produtos NFCe"
          createButtonText="Cadastrar Mapeamento"
          operationKlassToCheckPermission="Admin::ProductNfceMappings::Create"
          dataTestid="create_product_nfce_mapping_button"
          disableCreateButton={isPendingProductNfceMappings || productNfceMappingsError?.status === 403}
        />

        <ErrorMessageWrapper
          className="h-[calc(100vh-128px)]"
          statusCode={productNfceMappingsError?.status}
          refetchFunction={refetchProductNfceMappings}
        >
          <div className="h-[calc(100vh-128px)] flex flex-col gap-6">
            <div className="flex flex-col gap-4">
              <TextField
                LeftIcon={<Search />}
                placeholder="Pesquisar"
                className="rounded-sm shadow-[4px_0px_16px_0px_rgba(0,_0,_0,_0.5)]"
                onChange={(e) => {
                  setSearch((e.target as HTMLInputElement).value)
                  setFilterParams((prev) => ({ ...prev, search: (e.target as HTMLInputElement).value }))
                }}
                value={filterParams.search}
              />
            </div>

            <Table
              columns={defaultColumns}
              isLoadingData={isLoadingProductNfceMappings}
              page={filterParams.page || 1}
              rows={productNfceMappings}
              totalPages={meta.total_pages}
              totalCount={meta.total}
              hasPagination
              setPage={(page) => setFilterParams((prev) => ({ ...prev, page }))}
              rowEmptyValue="--"
            />
          </div>
        </ErrorMessageWrapper>
      </div>
    </div>
  )
}

export default ProductNfceMappingsList
